import _extends from "@babel/runtime/helpers/extends";
import { Checkbox } from '@atlaskit/checkbox';
import { CheckboxField, FormSection } from '@atlaskit/form';
import SectionMessage from '@atlaskit/section-message';
import { DateUtils } from '@atlassian/mpac-utils';
import React, { useState } from 'react';
import IssueKeyInput from "../IssueKeyInput";
export const SecuritySelfAssessmentInfo = ({
  issueKey,
  expiryDate
}) => issueKey && expiryDate ? /*#__PURE__*/React.createElement(SectionMessage, null, /*#__PURE__*/React.createElement("p", null, "Application ", /*#__PURE__*/React.createElement("a", {
  href: "https://ecosystem.atlassian.net/browse/".concat(issueKey)
}, issueKey), " is valid until ", DateUtils.longDate(expiryDate), ".")) : null;

const PartnerAdminSecurity = ({
  isApproved,
  issueKey,
  expiryDate
}) => {
  const [isSecurityApproved, setSecurityApproved] = useState(isApproved);

  const onChange = () => {
    setSecurityApproved(!isSecurityApproved);
  };

  return /*#__PURE__*/React.createElement(FormSection, {
    title: "Security Self-Assessment Program"
  }, /*#__PURE__*/React.createElement(SecuritySelfAssessmentInfo, {
    expiryDate: expiryDate,
    issueKey: issueKey
  }), /*#__PURE__*/React.createElement(CheckboxField, {
    name: "isSecurityApproved",
    defaultIsChecked: isSecurityApproved
  }, ({
    fieldProps
  }) => /*#__PURE__*/React.createElement(Checkbox, _extends({}, fieldProps, {
    label: "The partner's security application is approved",
    onChange: onChange
  }))), isSecurityApproved ? /*#__PURE__*/React.createElement(IssueKeyInput, {
    issueKey: issueKey
  }) : null);
};

export default PartnerAdminSecurity;